module.exports = __webpack_public_path__ + "static/media/DariusFleming.91f520e7.jpg";